import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { PAGE_TITLE } from '../../shared/enums/adsreports_enum';
import EnhancedGoogleAdsTable from './_components/google-ads-table';
import GoogleAdsCustomersReport from './_components/GoogleAdsCustomersReport';

const AllAdsreports = () => {
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);

  // Check if customerId is present in URL - if so, default to campaigns tab
  const hasCustomerId = params.get('customerId');
  const initialTab = hasCustomerId
    ? 'campaigns'
    : params.get('tab') || 'customers';

  const [activeTab, setActiveTab] = useState(initialTab);

  // Sync with url if changed externally (like Facebook Ads)
  useEffect(() => {
    const p = new URLSearchParams(location.search);
    const hasCustomer = p.get('customerId');
    const t = hasCustomer ? 'campaigns' : p.get('tab') || 'customers';
    if (t !== activeTab) setActiveTab(t);
  }, [location.search, activeTab]);

  // URL-aware tab change handler (like Facebook Ads)
  const handleTabChange = (newTab) => {
    if (newTab === activeTab) return;
    const p = new URLSearchParams(location.search);

    // When switching to customers tab, clear customer selection
    if (newTab === 'customers') {
      p.delete('customerId');
      p.delete('selectedCustomer');
    }

    p.set('tab', newTab);
    history.push({ pathname: location.pathname, search: p.toString() });
    setActiveTab(newTab);
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_TITLE}
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink={PAGE_TITLE}
        />

        {/* Tabs Navigation */}
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='tabs-container mb-4'>
                <div className='tabs-header'>
                  {/* <div
                    style={{
                      fontSize: '12px',
                      color: '#666',
                      padding: '8px 16px',
                      background: '#f1f1f1',
                    }}
                  >
                    Current Active Tab: {activeTab}
                  </div> */}
                  <button
                    className={`tab-btn ${
                      activeTab === 'customers' ? 'active' : ''
                    }`}
                    onClick={() => handleTabChange('customers')}
                  >
                    <i
                      className='fa fa-users'
                      style={{ marginRight: '8px' }}
                    ></i>
                    Google Ads Customers
                  </button>
                  <button
                    className={`tab-btn ${
                      activeTab === 'campaigns' ? 'active' : ''
                    }`}
                    onClick={() => handleTabChange('campaigns')}
                  >
                    <i
                      className='fa fa-bullhorn'
                      style={{ marginRight: '8px' }}
                    ></i>
                    Google Ads Campaigns
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className='tab-content'>
          {activeTab === 'campaigns' && (
            <div className='campaigns-tab'>
              <EnhancedGoogleAdsTable />
            </div>
          )}
          {activeTab === 'customers' && (
            <div className='customers-tab'>
              <GoogleAdsCustomersReport />
            </div>
          )}
        </div>

        <style jsx>{`
          .tabs-container {
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            overflow: hidden;
          }

          .tabs-header {
            display: flex;
            background: #f8f9fa;
            border-bottom: 1px solid #e5e7eb;
          }

          .tab-btn {
            display: flex;
            align-items: center;
            padding: 16px 24px;
            border: none;
            background: transparent;
            color: #6b7280;
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s ease;
            border-bottom: 3px solid transparent;
            position: relative;
            z-index: 1;
          }

          .tab-btn:hover {
            background: #e5e7eb;
            color: #374151;
            transform: translateY(-1px);
          }

          .tab-btn.active {
            background: white;
            color: #4285f4;
            border-bottom-color: #4285f4;
            font-weight: 600;
            box-shadow: 0 2px 4px rgba(66, 133, 244, 0.1);
          }

          .tab-content {
            margin-top: 0;
          }

          .campaigns-tab,
          .customers-tab {
            background: #f8f9fa;
            min-height: 500px;
          }
        `}</style>
      </div>
    </div>
  );
};

export default AllAdsreports;
